import { Host, h } from '@stencil/core';
export class AibaChip {
  constructor() {
    this.handleClickChip = (event) => {
      this.handleClick(event);
    };
    this.styles = undefined;
    this.classes = undefined;
    this.innerClasses = undefined;
    this.data = undefined;
    this.handleClick = undefined;
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `chip-wrapper ${this.classes ? this.classes : ''}`, tabIndex: this.handleClick ? 0 : null, role: this.handleClick ? 'button' : '', onClick: (event) => this.handleClickChip && this.handleClickChip(event), onKeyDown: e => {
        if (e.key === 'Enter') {
          this.handleClickChip && this.handleClickChip(e);
        }
      } }, h("div", { class: `chip-inner-wrapper ${this.innerClasses ? this.innerClasses : ''}` }, this.data &&
      this.data.elements &&
      ((_a = this.data.elements) === null || _a === void 0 ? void 0 : _a.map((element) => {
        if (element && element['name'] === 'span')
          return (h("span", { "aria-label": element === null || element === void 0 ? void 0 : element.data['text'], key: element === null || element === void 0 ? void 0 : element.data['text'], class: `${element && element['data'] && element['data']['classes'] ? element['data']['classes'] : ''}` }, element === null || element === void 0 ? void 0 : element.data['text']));
      }))))));
  }
  static get is() { return "aiba-chip"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-chip.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-chip.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "innerClasses": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "inner-classes",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-chip.js.map
